import { render, staticRenderFns } from "./DAOFund.vue?vue&type=template&id=33bb47af&scoped=true&"
import script from "./DAOFund.vue?vue&type=script&lang=js&"
export * from "./DAOFund.vue?vue&type=script&lang=js&"
import style0 from "./DAOFund.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DAOFund.vue?vue&type=style&index=1&id=33bb47af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb47af",
  null
  
)

export default component.exports